import { CachedItem } from "@lib-shared/lib";
import { appSettings } from "core/config";
import { Key } from "core/constants";

const contactDetailsCache = new CachedItem(Key.contactDetails);

// Scrolls element into view. The interval is there in case 
// the element in not yet in the DOM 
export const scrollToElement = (elementId: string, interval = 250) => {
    const element = document.getElementById(elementId);

    if (element === null) {
        setTimeout(() => scrollToElement(elementId), interval);
        return;
    }

    element.scrollIntoView();
}

export const getHtmlLink = (url: string, text: string | null = null, openNewTab = false) => {
    return `<a href=${url} target=${openNewTab ? "_blank" : "_self"}>${text ?? url}</a>`;
}

export const getDashboardHtmlLink = (openNewTab = true) => {
    const dashboardUrl = appSettings.urls.dashboard;
    return getHtmlLink(dashboardUrl, "Dashboard", openNewTab);
}

export const getContactDetailsHtml = () => {
    const contactDetailsHtml = getCustomerCareHtml();

    //contactDetailsHtml += getSocialLinksHtml();

    return contactDetailsHtml;
}

export const getCustomerCareHtml = () => {
    let customerCareHtml = getContactNumberHtml();
    customerCareHtml += customerCareHtml ? `<br/>${getContactEmailHtml()}` : getContactEmailHtml();

    return customerCareHtml;
}

export const getContactTimesHtml = () => {
    const contactDetails = contactDetailsCache.value;

    if (!contactDetails) {
        return "";
    }

    return contactDetails.contactTimes ?? "";
}

export const getContactNumberHtml = () => {
    const contactNumber = getContactNumber();
    if (!contactNumber) {
        return "";
    }

    return `<b>Contact Number</b>: ${contactNumber}`;
}

export const getContactNumber = () => {
    const contactDetails = contactDetailsCache.value;

    if (!contactDetails) {
        return "";
    }

    return contactDetails.contactNumber;
}

export const getContactEmailHtml = () => {
    const contactEmail = getContactEmail();

    if (!contactEmail) {
        return "";
    }

    return `<b>Email</b>: ${contactEmail}`;
}

export const getContactEmail = () => {
    const contactDetails = contactDetailsCache.value;

    if (!contactDetails) {
        return "";
    }

    return contactDetails.email;
}

export const getSocialLinksHtml = () => {
    const contactDetails = contactDetailsCache.value;

    if (!contactDetails) {
        return "";
    }

    let socialLinksHtml = "";

    contactDetails.socialLinks.forEach((x: { type: string; url: string; }) => {
        socialLinksHtml += `<br/>${x.type}: ${getHtmlLink(x.url, null, true)}`;
    });

    return socialLinksHtml;
}
